import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { notification } from 'antd';

import { editUser, getUser, signedUploadUrl, uploadUserAvi } from '../../../../actions'
import UserAvatar from '../../atoms/ticket-drawer/UserAvatar';

function ProfilePicture({ user }) {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [newPicture, setNewPicture] = useState(null);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleFileChange = async (event) => {
    const file = event?.target?.files[0];
    const imgExtensions = ['png', 'jpg', 'jpeg', 'svg', 'gif', 'webp'];

    if (imgExtensions?.includes(file?.type?.split('/')?.[1])) {
      const newFile = await toBase64(event.target.files[0]);
      setNewPicture(newFile);
      const { signedUrl, path } = await dispatch(uploadUserAvi(
        {
          fileName: file?.name,
          type: file?.type,
          fileSize: file?.size
        }
      ));
      if (signedUrl) {
        await dispatch(signedUploadUrl(signedUrl, file));
      }
      await dispatch(
        editUser(
          {
            _id: user._id,
            avi: path,
          },
          async () => {
            // await dispatch(getUser(user._id));
          }
        )
      );
    } else {
      notification.error({
        message: 'Invalid File Format',
        placement: 'bottomRight',
      })
    }
  };

  const handleUpload = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/jpeg,image/png';
    fileInput.onchange = handleFileChange;
    fileInput.click();
  }

  return (
    <div className='flex flex-col align-center'>
      <UserAvatar
        tooltip={intl.formatMessage({ id: 'CHANGE_PROFILE_PIC', defaultMessage: 'Change profile picture' })}
        alt="User upload"
        classNames="rounded-full cursor-pointer"
        fullName={user?.fullName}
        userId={user?._id}
        onClick={() => handleUpload()}
        src={newPicture || user?.avi}
        styles={{
          height: 200,
          width: 200,
          objectFit: 'cover',
        }}
      />
      <p onClick={() => handleUpload()} className='my-3 text-blue-500 underline cursor-pointer'>Upload profile picture</p>
    </div>
  );
}

export default ProfilePicture;